import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Tabs, Tab } from 'Core/components';
import WaterTowersDetailsForm from './water-towers-details-form';
import CustomPropTypes from 'Core/prop-types';
import { AppModal } from '../components/app-modals';
import { showToast } from 'Core/redux/toast/slice';
import WaterTowersMaintenanceHistory from './water-towers-maintenance-history';
import SafetyChecklist from './safety-checklist';
import CellHistory from './cell-history';
import SafetyChecklistHistory from './safety-checklist-history';
import EditWaterTowers from './edit-water-towers';

const saveKeys = ['changed', 'id', 'isDeleted', 'userId'];
const editKeys = ['changed', 'isDeleted'];

const WaterTowersAddEdit = ({ showModal, modalData, onCloseModal }) => {
  console.log('WaterTowersAddEdit -> modalData:', modalData);
  const waterTowersData = modalData;
  const [formData, setFormData] = useState(waterTowersData || null);
  const [cellData, setCellData] = useState(null);
  const [safetyData, setSafetyData] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  console.log('WaterTowersAddEdit -> formData?.id:', formData?.id);
  console.log('WaterTowersAddEdit -> formData?.waterTowerId:', formData?.waterTowerId);

  const dispatch = useDispatch();
  const isEditMode = Boolean(waterTowersData?.id || waterTowersData?.assetNumber);

  const onChangesWaterTowersForm = data => {
    setFormData(data);
  };

  const onCellHistoryActionClick = (data, mode) => {
    setCellData({ data: data, mode: mode });
    setActiveTabIndex(1);
  };

  const onSafetyChecklistHistActionClick = (data, mode) => {
    setSafetyData({ mode: mode });
    setActiveTabIndex(3);
  };

  const handleTabChange = (newTabIndex) => {
    if (activeTabIndex === 1 && newTabIndex !== 1) {
      setCellData(null);
    }
    if (activeTabIndex === 3 && newTabIndex !== 3) {
      setSafetyData(null);
    }
    setActiveTabIndex(newTabIndex);
  };

  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <div className="row">
        {isEditMode && (
          <Tabs activeIndex={activeTabIndex} onTabChange={handleTabChange}>
            <Tab title="Edit Water Tower">
              <EditWaterTowers
                data={formData}
                onChanges={onChangesWaterTowersForm}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Water Tower Maintenance Details">
              <WaterTowersDetailsForm
                data={formData}
                isEditMode={true}
                cellActionRecord={cellData}
                onChanges={onChangesWaterTowersForm}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Maintenance Records History">
              <WaterTowersMaintenanceHistory
                data={formData}
                waterTowersId={formData?.waterTowerId || formData?.id}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Safety Checklist">
              <SafetyChecklist 
                waterTowerId={formData?.waterTowerId || formData?.id}
                onCloseModal={handleClose}
                safetyActionRecord={safetyData}
              />
            </Tab>
            <Tab title="Cell History">
              <CellHistory
                assetNumber={formData.assetNumber}
                onActionClick={onCellHistoryActionClick}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Safety Checklist History">
              <SafetyChecklistHistory
                data={formData}
                onChanges={onChangesWaterTowersForm}
                onCloseModal={handleClose}
                waterTowerId={formData?.waterTowerId || formData?.id}
                onActionClick={onSafetyChecklistHistActionClick}
              />
            </Tab>
          </Tabs>
        )}
        {!isEditMode && (
          <EditWaterTowers
            data={formData}
            onChanges={onChangesWaterTowersForm}
            onCloseModal={handleClose}
          />
        )}
      </div>
    );
  };

  const valid = () => {
    const ignoreKeys = isEditMode ? editKeys : saveKeys;
    if (
      !formData ||
      Object.keys(formData).some(key => {
        return !ignoreKeys.includes(key) && !formData[key];
      })
    ) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  return (
    <Modal
      id="water-towers-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'Water Tower Maintenance Summary' : 'Add Water Tower'}
      body={body}
      handleClose={handleClose}
    />
  );
};

WaterTowersAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.Machines),
  onCloseModal: PropTypes.func,
};

export default AppModal(WaterTowersAddEdit);
